import { render, staticRenderFns } from "./lucky-card-dialog.vue?vue&type=template&id=0bca7099&scoped=true&"
import script from "./lucky-card-dialog.vue?vue&type=script&lang=js&"
export * from "./lucky-card-dialog.vue?vue&type=script&lang=js&"
import style0 from "./lucky-card-dialog.vue?vue&type=style&index=0&id=0bca7099&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca7099",
  null
  
)

export default component.exports